import "../../../../vendor/comscore.js";

(function() {
    ns_.analytics.UserConsent = {
        NO_CONSENT: "0",
        CONSENT_GIVEN:  "1",
        UNSPECIFIED: ""
    }

    ns_.analytics.UserPseudoType = {
        LOGGED_IN: "li",
        LOGGED_OUT: "lo",
        OPEN_ID: "o",
        FIRST_PARTY_COOKIE: "c"
    }
    ns_.analytics.DemographicsType = {
        COLLECTED_BY_PUBLISHER: "01",
        COLLECTED_BY_THIRD_PARTY: "02",
        MIXED_SOURCE_OR_MODELLED: "03",
        UNKNOWN_ORIGIN: "99"
    }
})();